import axios from 'axios';
import state from "../store";

const baseURL = state.getters.mainAppURL + "restaurants/";
const getAllRestaurant = () => axios.post(baseURL + "get_all_restaurants");
const getAllBranchesOfRestaurant = restaurant_id => axios.post(baseURL + "get_all_branches", restaurant_id);
const uploadMenuItemImages = (params, config) => axios.post( baseURL + "upload_menu_item_images", params, config);
const deleteMenuItemImage = (menuItemImageId, params) => axios.post(baseURL + "delete_menu_item_image/" + menuItemImageId, params);
const getMenuItemById = menuItemId => axios.get(baseURL + "get_menu_item_by_id/" + menuItemId);
const toggleMenuItemById = (menuItemId, params) => axios.put( baseURL + "toggle_menu_item/"+ menuItemId, params);
const applyDiscountOnMenuItem = (branchId, params) => axios.put( baseURL + "disable_discounts_in_branch_menu/" + branchId, params);
const deleteCoupon = (couponId) => axios.delete(baseURL + "delete_coupon_by_id/" + couponId);
const getOptimizedBranch = (restaurantId, areaId) => axios.get( baseURL + "optimized_branch/" + restaurantId + "/" + areaId);

export {
    getAllRestaurant,
    getAllBranchesOfRestaurant,
    uploadMenuItemImages,
    deleteMenuItemImage,
    getMenuItemById,
    toggleMenuItemById,
    applyDiscountOnMenuItem,
    deleteCoupon,
    getOptimizedBranch
}